<template>
    <div v-if="count > 1 && loaded" class="mb-2">
        <div v-if="inline" class="form-inline">
            <label for="class-select" class="my-1 me-2">{{ $t('Velg klasse') }}:</label>
            <select name="class-select" id="class-select" class="form-select my-1 me-sm-2 custom-select-sm" v-model="id" @change="select">
                <option :value="null" :selected="id === null">- {{ $t('Velg klasse') }} -</option>
                <option v-for="(className, classId) in list" :value="classId" :selected="id == classId">{{ className }}</option>
            </select>
        </div>
        <div v-if="!inline">
            <p class="font-sm text-elev-blue-dim mb-2"><strong>{{ $t('Klasse') }}</strong></p>
            <select name="class-select" class="form-select" v-model="id" @change="select">
                <option :value="null" :selected="id === null">- {{ $t('Velg klasse') }} -</option>
                <option v-for="(className, classId) in list" :value="classId" :selected="id == classId">{{ className }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Api from '../../api/User'

const props = defineProps(['inline', 'exclude', 'refresh', 'classname', 'classid'])
const emit = defineEmits(['loaded', 'change'])

const list = ref({})
const id = ref(null)
const name = ref(null)
const count = ref(1)
const loaded = ref(false)

const current = computed(() => name.value)

const select = () => {
    Api.SetClass(id.value).then(res => {
        name.value = list.value[id.value]

        if (props.refresh !== false) {
            window.location.reload()
        } else {
            emit('change', { id: id.value })
        }
    }).catch(e => {
        console.error(e)
    })
}

onMounted(() => {
    // Get initial values from attrs
    name.value = props.classname
    id.value = props.classid

    Api.Classlist(props.exclude).then(res => {
        list.value = res.data.classlist
        count.value = res.data.count
        id.value = res.data.currentClass.id
        name.value = res.data.currentClass.name
        loaded.value = true
        emit('loaded', { id: id.value })
    })
})
</script>
